import script from "./DownloadTimetableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadTimetableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadTimetableBlock.vue?vue&type=style&index=0&id=4b5d8d06&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5d8d06"]])

export default __exports__